module.exports = __webpack_public_path__ + "img/toolbar_logo.webp";